import { render } from "./Testimonials.vue?vue&type=template&id=4b9c9837&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=4b9c9837&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9c9837"]])

export default __exports__